// Admin Analytics Action Types
export const FETCH_USER_ANALYTICS_REQUEST = "FETCH_USER_ANALYTICS_REQUEST";
export const FETCH_USER_ANALYTICS_SUCCESS = "FETCH_USER_ANALYTICS_SUCCESS";
export const FETCH_USER_ANALYTICS_FAILURE = "FETCH_USER_ANALYTICS_FAILURE";

export const FETCH_REVENUE_ANALYTICS_REQUEST = "FETCH_REVENUE_ANALYTICS_REQUEST";
export const FETCH_REVENUE_ANALYTICS_SUCCESS = "FETCH_REVENUE_ANALYTICS_SUCCESS";
export const FETCH_REVENUE_ANALYTICS_FAILURE = "FETCH_REVENUE_ANALYTICS_FAILURE";

export const FETCH_CONTENT_ANALYTICS_REQUEST = "FETCH_CONTENT_ANALYTICS_REQUEST";
export const FETCH_CONTENT_ANALYTICS_SUCCESS = "FETCH_CONTENT_ANALYTICS_SUCCESS";
export const FETCH_CONTENT_ANALYTICS_FAILURE = "FETCH_CONTENT_ANALYTICS_FAILURE";

export const FETCH_PLATFORM_ANALYTICS_REQUEST = "FETCH_PLATFORM_ANALYTICS_REQUEST";
export const FETCH_PLATFORM_ANALYTICS_SUCCESS = "FETCH_PLATFORM_ANALYTICS_SUCCESS";
export const FETCH_PLATFORM_ANALYTICS_FAILURE = "FETCH_PLATFORM_ANALYTICS_FAILURE";

export const FETCH_BEST_BOOKS_REQUEST = "FETCH_BEST_BOOKS_REQUEST";
export const FETCH_BEST_BOOKS_SUCCESS = "FETCH_BEST_BOOKS_SUCCESS";
export const FETCH_BEST_BOOKS_FAILURE = "FETCH_BEST_BOOKS_FAILURE";

export const FETCH_MOST_ACTIVE_USERS_REQUEST = "FETCH_MOST_ACTIVE_USERS_REQUEST";
export const FETCH_MOST_ACTIVE_USERS_SUCCESS = "FETCH_MOST_ACTIVE_USERS_SUCCESS";
export const FETCH_MOST_ACTIVE_USERS_FAILURE = "FETCH_MOST_ACTIVE_USERS_FAILURE";

export const FETCH_TOP_SPENDERS_REQUEST = "FETCH_TOP_SPENDERS_REQUEST";
export const FETCH_TOP_SPENDERS_SUCCESS = "FETCH_TOP_SPENDERS_SUCCESS";
export const FETCH_TOP_SPENDERS_FAILURE = "FETCH_TOP_SPENDERS_FAILURE";

// User Management Action Types
export const FETCH_ALL_USERS_REQUEST = "FETCH_ALL_USERS_REQUEST";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILURE = "FETCH_ALL_USERS_FAILURE";

export const FETCH_USER_STATUS_COUNTS_REQUEST = "FETCH_USER_STATUS_COUNTS_REQUEST";
export const FETCH_USER_STATUS_COUNTS_SUCCESS = "FETCH_USER_STATUS_COUNTS_SUCCESS";
export const FETCH_USER_STATUS_COUNTS_FAILURE = "FETCH_USER_STATUS_COUNTS_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const SUSPEND_USER_REQUEST = "SUSPEND_USER_REQUEST";
export const SUSPEND_USER_SUCCESS = "SUSPEND_USER_SUCCESS";
export const SUSPEND_USER_FAILURE = "SUSPEND_USER_FAILURE";

export const UNSUSPEND_USER_REQUEST = "UNSUSPEND_USER_REQUEST";
export const UNSUSPEND_USER_SUCCESS = "UNSUSPEND_USER_SUCCESS";
export const UNSUSPEND_USER_FAILURE = "UNSUSPEND_USER_FAILURE";

export const BAN_USER_REQUEST = "BAN_USER_REQUEST";
export const BAN_USER_SUCCESS = "BAN_USER_SUCCESS";
export const BAN_USER_FAILURE = "BAN_USER_FAILURE";

export const UNBAN_USER_REQUEST = "UNBAN_USER_REQUEST";
export const UNBAN_USER_SUCCESS = "UNBAN_USER_SUCCESS";
export const UNBAN_USER_FAILURE = "UNBAN_USER_FAILURE";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const UPDATE_USER_ROLE_REQUEST = "UPDATE_USER_ROLE_REQUEST";
export const UPDATE_USER_ROLE_SUCCESS = "UPDATE_USER_ROLE_SUCCESS";
export const UPDATE_USER_ROLE_FAILURE = "UPDATE_USER_ROLE_FAILURE";
